import './RequestedEffectiveDate.css';

import React from 'react';

import { EFFECTIVE_DATE_COPY } from '../../effectiveDateCopy';
import { formatEffectiveDate } from '../../effectiveDateRules';

interface RequestedEffectiveDateProps {
  coverageStartDate: string;
  previousCoverageStartDate?: string;
  showUpdatedNote: boolean;
  /** Omitted when the date is read-only here. */
  onEdit?: () => void;
}

// MET-468: the requested effective date, between Premium and Buy Now.
const RequestedEffectiveDate: React.FC<RequestedEffectiveDateProps> = ({
  coverageStartDate,
  previousCoverageStartDate,
  showUpdatedNote,
  onEdit
}) => {
  const previousDate = formatEffectiveDate(previousCoverageStartDate);

  return (
    <div
      className="requested-effective-date w-full lg:max-w-xs"
      data-testid="requested-effective-date"
    >
      <div className="flex justify-between items-center">
        <p className="text-sm">{EFFECTIVE_DATE_COPY.cardTitle}</p>
        {onEdit ? (
          <button
            type="button"
            className="text-sm underline font-bold text-secondary"
            data-testid="requested-effective-date-edit"
            onClick={onEdit}
          >
            {EFFECTIVE_DATE_COPY.cardEdit}
          </button>
        ) : null}
      </div>
      <p
        className="font-bold text-lg"
        data-testid="requested-effective-date-value"
      >
        {formatEffectiveDate(coverageStartDate) ?? '—'}
      </p>
      {showUpdatedNote && previousDate ? (
        <p
          className="text-sm text-yellow-800"
          data-testid="requested-effective-date-updated-note"
        >
          {EFFECTIVE_DATE_COPY.cardUpdatedFrom(previousDate)}
        </p>
      ) : null}
    </div>
  );
};

export default RequestedEffectiveDate;
